import {EventBus} from "../../../../../common/ts/events/EventBus";
import {AddFreeTextValueEvent, ChipCloseEvent, ChipContainerUpdatedEvent} from "./events";
import {WhitelabelEvent} from "../../../../../common/ts/events/Events";
import dom from "../../../../../common/ts/core/dom";
import {
    DISPLAYED_CSS_CLASS,
    FILTER_NUMBER_CSS_CLASS,
    FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR,
    FREE_TEXT_INPUT_FILTER_NUMBER_SELECTOR
} from "./constants";

let eventBus: EventBus;

export function chipContainerUpdatedEventHandler(event: WhitelabelEvent) {
    const {payload: {containerElement}} = (event as ChipContainerUpdatedEvent);
    const freeTextFilter = document.querySelectorAll('.free-text-input.filter-number');

    if (containerElement && freeTextFilter) {
        freeTextFilter.forEach((filter: Element) => {
            const filterHtmlElement = filter as HTMLElement;
            const chips = containerElement.querySelectorAll('wl-chip');
            const chipCount = chips.length;

            if (chipCount === 0) {
                eventBus.emit(new dom.AddClassEvent({selector: FREE_TEXT_INPUT_FILTER_NUMBER_SELECTOR, className: FILTER_NUMBER_CSS_CLASS}));
            } else {
                eventBus.emit(new dom.RemoveClassEvent({selector: FREE_TEXT_INPUT_FILTER_NUMBER_SELECTOR, className: FILTER_NUMBER_CSS_CLASS}));
                filterHtmlElement.textContent = chipCount.toString();
                displayDesktopChipsContainer();
            }
        });
    }
}

export function chipCloseEventHandler(event: WhitelabelEvent) {
    const {payload: {containerElement, chip}} = (event as ChipCloseEvent);

    if (chip && containerElement.contains(chip)) {
        containerElement.removeChild(chip);
        const chips = containerElement.querySelectorAll('wl-chip');
        updateChipValues(chips);
        eventBus.emit(new ChipContainerUpdatedEvent({containerElement: containerElement}));
    }

}

export function addFreeTextValueEventHandler(event: WhitelabelEvent) {
    const {payload: {inputElement, chipContainer}} = (event as AddFreeTextValueEvent);
    const inputValue = inputElement?.value;

    if (inputValue && inputValue.trim() !== '') {
        const wlChip = document.createElement('wl-chip');
        wlChip.setAttribute('withCrossIcon', '');
        wlChip.textContent = inputValue;

        chipContainer.forEach((container: Element) => {
            container.appendChild(wlChip);

            const chips = container.querySelectorAll('wl-chip');
            updateChipValues(chips, inputValue);

            eventBus.emit(new ChipContainerUpdatedEvent({containerElement: container}));
            clearInputValue(inputElement);
        });
    }
}


function updateChipValues(chips: NodeListOf<Element>, lastChipValue: string | null = null) {
    const chipValues: string[] = [];
    chips.forEach((chip) => {
        const slot = chip.shadowRoot?.querySelector("slot");
        if (!slot) {
            return;
        }

        const assignedNodes = slot.assignedNodes();
        if (!assignedNodes || assignedNodes.length === 0) {
            return;
        }

        const chipValue = assignedNodes[0]?.textContent?.trim();

        if (chipValue && chipValue !== '') {
            chipValues.push(chipValue);
        }
    });

    if (lastChipValue) {
        chipValues.push(lastChipValue);
    }

    const hiddenFreeTextInput = dom.selectAll('input[name="freeText"]');

    hiddenFreeTextInput?.forEach((input: Element) => {
        const inputElement = input as HTMLInputElement;
        inputElement.setAttribute('value', chipValues.join(","));
    });
}

function clearInputValue(wlTextInput: HTMLInputElement | undefined) {
    if (wlTextInput?.value) {
        wlTextInput.value = '';
    }
}

function displayDesktopChipsContainer() {
    eventBus.emit(new dom.AddClassEvent({
        selector: FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR,
        className: DISPLAYED_CSS_CLASS
    }));
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(ChipContainerUpdatedEvent.TYPE, chipContainerUpdatedEventHandler)
    eventBus.subscribe(ChipCloseEvent.TYPE, chipCloseEventHandler)
    eventBus.subscribe(AddFreeTextValueEvent.TYPE, addFreeTextValueEventHandler)
}

export default {
    init
};
